import React from 'react';
import { Card, Flex, Box, Button, Text } from '../../../../design-system';
import { LAST_UPDATED_COLUMN } from '../../../shared-constants';
import { required, emailVal } from '../../../../helpers/utils';
import DeadlineCell from '../../../../components/DeadlineCell';
import DeleteButton from '../../../../components/DeleteButton';
import StyledLink from '../../../../components/StyledLink';
import DescriptionTooltip from '../../../../components/DescriptionTooltip';
import EllipsisDropdown from '../../../../components/EllipsisDropdown';

export const COLUMNS = [
  { Header: 'Name', accessor: 'name' },
  {
    Header: 'Website',
    accessor: 'website',
    Cell: ({ cell: { value } }) => value && <a href={value}>{value}</a>,
  },

  {
    Header: 'Description',
    accessor: 'description',
    Cell: DescriptionTooltip,
  },
  {
    Header: 'Expires',
    accessor: 'expires',
    type: 'date',
    Cell: DeadlineCell,
  },
  { ...LAST_UPDATED_COLUMN },
  {
    Header: '',
    accessor: 'handleDeletePartnership',
    Cell: ({ row: { original }, cell: { value: handleDeletePartnership } }) => (
      <Button.Group justifyContent="flex" alignItems="center">
        <StyledLink
          to={`/vault/${original.client_id}/partnerships/${original.id}`}
        >
          <Text id="expand-button">more info</Text>
        </StyledLink>
        {original.canEdit && (
          <DeleteButton onClick={() => handleDeletePartnership(original)} />
        )}
      </Button.Group>
    ),
  },
];

export const MODAL_FIELDS = [
  { name: 'name', label: 'Name', validate: required },
  { name: 'website', label: 'Website' },
  {
    name: 'description',
    label: 'Description',
    multiline: true,
  },
  {
    name: 'expires',
    label: 'Expires',
    type: 'date',
  },
];

export const SINGLE_ENTITY_FIELDS = [
  {
    label: 'Name',
    name: 'name',
  },
  {
    label: 'Website',
    name: 'website',
  },
  {
    label: 'Description',
    name: 'description',
  },
  {
    label: 'Expires',
    name: 'expires',
    type: 'date',
  },
];

export const CONTACT_COLUMNS = {
  primary: [
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'Title',
      accessor: 'title',
      Cell: ({ cell: { value } }) => value && value,
    },
    {
      Header: 'Phone',
      accessor: 'phone',
      Cell: ({ cell: { value } }) => value && value,
    },
    {
      Header: 'Email',
      accessor: 'email',
      Cell: ({ cell: { value } }) => value && value,
    },
  ],
  secondary: [
    {
      Header: 'Notes',
      accessor: 'notes',
      Cell: ({ cell: { value } }) =>
        value && (
          <>
            <Text fontWeight="bold" fontSize={14} mb={1}>
              Staff Note
            </Text>
            <Card p={1} mb={1}>
              <Flex alignItems="center">
                <Box>
                  <Text fontSize={13}>{value}</Text>
                </Box>
              </Flex>
            </Card>
          </>
        ),
    },
  ],
  actions: [
    {
      Header: '',
      accessor: 'edit',
      Cell: ({ row: { original } }) => {
        const options = [
          {
            id: 1,
            onClick: () => original.openEditModal(original),
            render: () => <Text>Edit Contact</Text>,
          },
          {
            id: 2,
            onClick: () => original.handleContactDelete(original.id),
            render: () => <Text>Delete Contact</Text>,
          },
        ];
        return original.canEdit ? <EllipsisDropdown options={options} /> : null;
      },
    },
  ],
};

export const CONTACT_MODAL_FIELDS = [
  { name: 'name', label: 'Name', validate: required },
  { name: 'title', label: 'Title' },
  { name: 'phone', label: 'Phone' },
  { name: 'email', label: 'Email', validate: emailVal },
  { name: 'notes', label: 'Notes', multiline: true, rows: 5 },
];
